import type {EncounterAnnotation} from "@/encounter/model/EncounterAnnotation.ts";

type Operation = {status: "idle" | "saving" | "deleting"} | {status: "failed"; message: string};
export type AnnotationEditorState = {draft?: EncounterAnnotation; editing: boolean; operation: Operation};
type Action = {type: "reset"} | {type: "select"; editing: boolean} | {type: "place"; draft: EncounterAnnotation}
    | {type: "draft"; draft: EncounterAnnotation} | {type: "editing"; editing: boolean}
    | {type: "start"; status: "saving" | "deleting"} | {type: "fail"; message: string}
    | {type: "finish" | "clearError"};
export const initialAnnotationEditor: AnnotationEditorState = {editing: false, operation: {status: "idle"}};

/** Editing and persistence are independent; persistence can never be both busy and failed. */
export function annotationEditorReducer(state: AnnotationEditorState, action: Action): AnnotationEditorState {
    switch (action.type) {
        case "reset": return initialAnnotationEditor;
        case "select": return {...initialAnnotationEditor, editing: action.editing};
        case "place": return {draft: action.draft, editing: true, operation: {status: "idle"}};
        case "draft": return {...state, draft: action.draft};
        case "editing": return {...state, editing: action.editing};
        case "start": return {...state, operation: {status: action.status}};
        case "fail": return {...state, operation: {status: "failed", message: action.message}};
        case "clearError": return state.operation.status === "failed" ? {...state, operation: {status: "idle"}} : state;
        case "finish": return state.operation.status === "failed" ? state : {...state, operation: {status: "idle"}};
    }
}
